(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inochi-ceremony-soon"]) return;
  try {
    
  (function() {
    var EDGE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/submit-tea-ceremony-lead';

    var form = document.getElementById('CeremonySoonForm');
    var btn = document.getElementById('CeremonySoonSubmit');
    var errBox = document.getElementById('CeremonySoonError');
    var successBox = document.getElementById('CeremonySoonSuccess');

    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.style.display = 'none';
      errBox.textContent = '';

      /* Each required checkbox says what IT is for, rather than one generic
         line that leaves someone hunting for the box they missed. */
      var CHECKBOX_ERRORS = {
        newsletter_signup: 'Please check "I consent to receiving member emails from Inochi" to continue.',
        sms_consent: 'Please check "I consent to receiving member texts from Inochi" to continue.'
      };

      var requiredFields = form.querySelectorAll('[required]');
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        /* A checkbox is never empty: its value is "Yes" whether or not it is
           ticked, so testing .value here would let an unticked box straight
           through. */
        if (field.type === 'checkbox') {
          if (!field.checked) {
            showError(CHECKBOX_ERRORS[field.name] || 'Please tick the boxes to continue.');
            field.focus();
            return;
          }
          continue;
        }
        if (!field.value.trim()) {
          showError('Please fill in all required fields.');
          field.focus();
          return;
        }
      }

      var payload = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        email: val('email'),
        phone: val('phone'),
        newsletter_signup: form.querySelector('[name="newsletter_signup"]').checked,
        sms_consent: form.querySelector('[name="sms_consent"]').checked
      };

      btn.disabled = true;
      btn.textContent = 'Submitting...';

      fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function(result) {
        if (result.ok) {
          form.style.display = 'none';
          successBox.style.display = 'block';
        } else {
          showError(result.data.error || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      })
      .catch(function() {
        showError('Unable to reach the server. Please check your connection and try again.');
        btn.disabled = false;
        btn.textContent = 'Submit';
      });
    });

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.style.display = 'block';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inochi-coming-soon"]) return;
  try {
    
  (function() {
    var EDGE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/submit-newsletter-signup';

    var form = document.getElementById('ComingSoonForm');
    var btn = document.getElementById('CsoonSubmit');
    var errBox = document.getElementById('CsoonError');
    var successBox = document.getElementById('CsoonSuccess');

    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.style.display = 'none';
      errBox.textContent = '';

      /* Each required checkbox says what IT is for, rather than one generic
         line that leaves someone hunting for the box they missed. */
      var CHECKBOX_ERRORS = {
        newsletter_signup: 'Please check "I consent to receiving member emails from Inochi" to continue.',
        sms_consent: 'Please check "I consent to receiving member texts from Inochi" to continue.'
      };

      var requiredFields = form.querySelectorAll('[required]');
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        /* A checkbox is never empty: its value is "Yes" whether or not it is
           ticked, so testing .value here would let an unticked box straight
           through. */
        if (field.type === 'checkbox') {
          if (!field.checked) {
            showError(CHECKBOX_ERRORS[field.name] || 'Please tick the boxes to continue.');
            field.focus();
            return;
          }
          continue;
        }
        if (!field.value.trim()) {
          showError('Please fill in all required fields.');
          field.focus();
          return;
        }
      }

      var payload = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        email: val('email'),
        phone: val('phone'),
        newsletter_signup: form.querySelector('[name="newsletter_signup"]').checked,
        sms_consent: form.querySelector('[name="sms_consent"]').checked,
        source: 'shopify-coming-soon'
      };

      btn.disabled = true;
      btn.textContent = 'Submitting...';

      fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function(result) {
        if (result.ok) {
          form.style.display = 'none';
          successBox.style.display = 'block';
        } else {
          showError(result.data.error || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      })
      .catch(function() {
        showError('Unable to reach the server. Please check your connection and try again.');
        btn.disabled = false;
        btn.textContent = 'Submit';
      });
    });

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.style.display = 'block';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inochi-complimentary-form"]) return;
  try {
    
  (function() {
    var EDGE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/submit-application';

    var form = document.getElementById('MembershipApplicationForm');
    var btn = document.getElementById('inochi-submit-btn');
    var errBox = document.getElementById('inochi-form-errors');
    var successBox = document.getElementById('inochi-form-success');

    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.style.display = 'none';
      errBox.textContent = '';

      /* Client-side required check.
         This used to say "Please fill in all required fields." and stop there,
         which on a form this long tells you nothing: the field it moved focus
         to could be far off screen, so the message read as a dead end. It names
         the field now, and scrolls it into view. */
      var requiredFields = form.querySelectorAll('[required]');
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        if (field.type === 'checkbox' && !field.checked) {
          showError(CHECKBOX_ERRORS[field.name] || 'Please accept the policies to continue.');
          revealField(field);
          return;
        }
        if (field.type !== 'checkbox' && !field.value.trim()) {
          var what = labelFor(field);
          showError(what ? 'Still missing: ' + what : 'Please fill in all required fields.');
          revealField(field);
          return;
        }
      }

      /* The phone box is prefilled with a calling code, so `required` on its own
         would happily accept "+1" and nothing else. E.164 allows 15 digits
         including the code and nothing real is shorter than 8: the same rule
         the edge function and the Klaviyo sync both apply, so a number that
         passes here cannot be dropped later. */
      var phoneDigits = (val('phone') || '').replace(/\D/g, '');
      if (phoneDigits.length < 8 || phoneDigits.length > 15) {
        showError('Please enter your phone number after the country code.');
        var phoneField = form.querySelector('[name="phone"]');
        if (phoneField) revealField(phoneField);
        return;
      }

      var payload = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        pronouns: val('pronouns'),
        email: val('email'),
        phone: val('phone'),
        country: val('country'),
        address_line1: val('address_line1'),
        address_line2: val('address_line2'),
        address_city: val('address_city'),
        address_state: val('address_state'),
        address_postal_code: val('address_postal_code'),
        address_country: val('address_country'),
        birthdate: toSlashDate(val('birthdate')),
        occupation: val('occupation'),
        social_media_handle: buildSocialHandle(),
        social_contributions: val('social_contributions'),
        passions: val('passions'),
        ambition: val('ambition'),
        passion_projects: val('passion_projects'),
        space_inspiration: val('space_inspiration'),
        why_join: val('why_join'),
        form_type: 'complimentary',
        how_did_you_hear: val('how_did_you_hear'),
        member_referrals: val('member_referrals'),
        newsletter_signup: form.querySelector('[name="newsletter_signup"]').checked,
        sms_consent: form.querySelector('[name="sms_consent"]').checked,
        accepted_terms: form.querySelector('[name="accepted_terms"]').checked
      };

      // Attach first-party traffic attribution (visitor id + first/last-touch source).
      try {
        if (window.InochiTracker && window.InochiTracker.getAttribution) {
          var attribution = window.InochiTracker.getAttribution();
          for (var attrKey in attribution) {
            if (Object.prototype.hasOwnProperty.call(attribution, attrKey)) {
              payload[attrKey] = attribution[attrKey];
            }
          }
        }
      } catch (attrErr) { /* attribution is best-effort — never block submission */ }

      btn.disabled = true;
      btn.textContent = 'Submitting...';

      fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function(result) {
        if (result.ok) {
          form.style.display = 'none';
          successBox.style.display = 'block';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          showError(result.data.error || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      })
      .catch(function() {
        showError('Unable to reach the server. Please check your connection and try again.');
        btn.disabled = false;
        btn.textContent = 'Submit';
      });
    });

    /* A few labels do not stand on their own once lifted out of the form.
       "Number" sits under a Phone heading and means nothing by itself. */
    /* Every required checkbox says what IT is for. Falling through to one
       generic line left someone hunting for which box they had missed. */
    var CHECKBOX_ERRORS = {
      newsletter_signup: 'Please check "I consent to receiving member emails from Inochi". That is how we email you about your application.',
      sms_consent: 'Please check "I consent to receiving member texts from Inochi" to continue.'
    };

    var FIELD_NAMES = {
      phone: 'Phone number',
      address_state: 'State / Province / Region',
      address_state_text: 'State / Province / Region'
    };

    /* The visible label for a field, so an error can name it rather than
       leaving someone to hunt through a long form for whatever is blank.
       Original capitalisation is kept, because several of these labels are
       whole questions and reading them back lowercased looks like a typo. */
    function labelFor(field) {
      if (field.name && FIELD_NAMES[field.name]) return FIELD_NAMES[field.name];
      var label = field.id ? form.querySelector('label[for="' + field.id + '"]') : null;
      if (!label) {
        var wrapper = field.closest ? field.closest('.inochi-field, .inochi-form-row, p, div') : null;
        label = wrapper ? wrapper.querySelector('label') : null;
      }
      if (!label) return '';
      return (label.textContent || '')
        .replace(/\(optional\)/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/[:*]+$/, '');
    }

    /* Focus alone can leave the field off screen on a long form. */
    function revealField(field) {
      try { field.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* older browsers */ }
      try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
    }

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    /* ── Country and state ────────────────────────────────────────────────
       The state field is a picker for the two countries we hold subdivisions
       for and a plain text box everywhere else, because guessing at another
       country's regions is worse than letting someone type their own. Only the
       visible one is ever submitted, so `address_state` carries a code for
       US and CA and free text elsewhere. */
    var SUBDIVISIONS = {
      US: [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],['AS','American Samoa'],['GU','Guam'],['MP','Northern Mariana Islands'],['PR','Puerto Rico'],['VI','U.S. Virgin Islands'],['AA','Armed Forces Americas'],['AE','Armed Forces Europe'],['AP','Armed Forces Pacific']],
      CA: [['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],['SK','Saskatchewan'],['YT','Yukon']]
    };
    /* ── Phone country code ───────────────────────────────────────────────
       The picker beside the phone box is what tells us how to read the number,
       so the box carries that country's calling code as real text rather than a
       grey hint. Switching country rewrites the code and keeps whatever has
       already been typed after it.

       The code is read from data-dial on the option itself, so this form holds
       no country table of its own and cannot drift out of step with the list.
       Regenerate both together in the portal repo:
         node scripts/generate-geo.mjs --options                              */
    var phoneCountrySel = form.querySelector('[name="country"]');
    var phoneInput = form.querySelector('[name="phone"]');
    var currentDial = '';

    function selectedDial() {
      var opt = phoneCountrySel && phoneCountrySel.options[phoneCountrySel.selectedIndex];
      return (opt && opt.getAttribute('data-dial')) || '';
    }

    /* rewrite=false on load: only fill an empty box, never clobber a value the
       browser restored. rewrite=true on change: swap the code we put there and
       carry the rest of the number across. */
    function applyDial(rewrite) {
      var next = selectedDial();
      if (!next || !phoneInput) return;
      var value = (phoneInput.value || '').trim();
      if (rewrite) {
        var head = currentDial ? '+' + currentDial : '';
        var rest = (head && value.indexOf(head) === 0) ? value.slice(head.length) : value;
        rest = rest.replace(/^[\s\-().]+/, '');
        phoneInput.value = rest ? '+' + next + ' ' + rest : '+' + next + ' ';
      } else if (!value) {
        phoneInput.value = '+' + next + ' ';
      }
      currentDial = next;
    }

    if (phoneCountrySel && phoneInput) {
      applyDial(false);
      phoneCountrySel.addEventListener('change', function () { applyDial(true); });
    }

    var countrySel = form.querySelector('[name="address_country"]');
    var stateSel = form.querySelector('#MFAddressState');
    var stateText = form.querySelector('#MFAddressStateText');
    var stateLabel = form.querySelector('label[for="MFAddressState"]');

    function syncStateField() {
      var list = SUBDIVISIONS[countrySel ? countrySel.value : 'US'];
      if (!stateSel || !stateText) return;

      if (list) {
        var placeholder = countrySel.value === 'CA' ? 'Select a province' : 'Select a state';
        stateSel.innerHTML = '<option value="">' + placeholder + '</option>' +
          list.map(function (row) { return '<option value="' + row[0] + '">' + row[1] + '</option>'; }).join('');
        stateSel.style.display = '';
        stateSel.disabled = false;
        stateSel.required = true;
        stateSel.name = 'address_state';
        stateText.style.display = 'none';
        stateText.disabled = true;
        stateText.required = false;
        stateText.name = 'address_state_text';
        if (stateLabel) stateLabel.textContent = countrySel.value === 'CA' ? 'Province' : 'State';
      } else {
        stateSel.style.display = 'none';
        stateSel.disabled = true;
        stateSel.required = false;
        stateSel.name = 'address_state_unused';
        stateText.style.display = '';
        stateText.disabled = false;
        stateText.required = true;
        stateText.name = 'address_state';
        if (stateLabel) stateLabel.textContent = 'State / Province / Region';
      }
    }

    if (countrySel) {
      countrySel.addEventListener('change', function () {
        // A California code means nothing in France, so the old answer goes.
        if (stateSel) stateSel.value = '';
        if (stateText) stateText.value = '';
        syncStateField();
      });
      syncStateField();
    }


    // Combine the Instagram & TikTok handles into the single social_media_handle
    // field the edge function / members portal already expect (keeps funnel intact)
    function buildSocialHandle() {
      var parts = [];
      var li = val('linkedin_handle').trim();
      var ig = val('instagram_handle').trim();
      var tt = val('tiktok_handle').trim();
      if (li) parts.push('LinkedIn: ' + li);
      if (ig) parts.push('Instagram: ' + ig);
      if (tt) parts.push('TikTok: ' + tt);
      return parts.join(' | ');
    }

    // Native date inputs emit YYYY-MM-DD; the members portal expects MM/DD/YYYY
    function toSlashDate(v) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
      return m ? m[2] + '/' + m[3] + '/' + m[1] : v;
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.style.display = 'block';
      errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inochi-membership-form"]) return;
  try {
    
  (function() {
    var EDGE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/submit-application';

    var form = document.getElementById('MembershipApplicationForm');
    var btn = document.getElementById('inochi-submit-btn');
    var errBox = document.getElementById('inochi-form-errors');
    var successBox = document.getElementById('inochi-form-success');

    if (!form) return;

    // ─── Member proposals ("Propose a New Member") ─────────────────────────
    // A member shares a link from the members portal; it redirects here with
    // ?ref=<token>, from the link a member generates in their portal. This is now
    // the ONLY way a referral is recorded: the typed "Member Referral" box was
    // removed because a misspelt name credited nobody and quietly promised the
    // applicant it had. Resolving the token here only names the proposer on
    // screen; the token itself rides along hidden and is re-resolved server
    // side, so nothing on this page is trusted for attribution.
    (function applyReferral() {
      var RESOLVE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/resolve-referral';
      var tokenField = document.getElementById('MFReferralToken');
      var banner = document.getElementById('inochi-form-proposed');
      var bannerText = document.getElementById('inochi-form-proposed-text');
      if (!tokenField || !banner) return;

      /* The token has to survive navigation without outliving the visit.
         Someone follows a member's link, reads the Membership page, comes back
         through the footer, and applies. Without this the ?ref= is gone by the
         time they submit and the proposer is never credited.

         sessionStorage on purpose, NOT localStorage. First-touch attribution is
         kept for days, and a real application showed exactly why that is wrong
         here: a browser that had opened a ?ref= link on 30 August applied
         normally on 4 September, five days later, with no referral involved.
         Persisting that long would have credited someone $100 for an
         application they had nothing to do with. sessionStorage dies with the
         browsing session, and the timestamp caps it tighter still. */
      var REF_KEY = 'inochi_ref_token';
      var REF_TTL_MS = 6 * 60 * 60 * 1000;

      function rememberRef(token) {
        try {
          window.sessionStorage.setItem(REF_KEY, JSON.stringify({ token: token, at: Date.now() }));
        } catch (e) { /* private mode, or storage disabled - the URL still works */ }
      }

      function recallRef() {
        try {
          var raw = window.sessionStorage.getItem(REF_KEY);
          if (!raw) return null;
          var saved = JSON.parse(raw);
          if (!saved || !saved.token) return null;
          if (!saved.at || Date.now() - saved.at > REF_TTL_MS) {
            window.sessionStorage.removeItem(REF_KEY);
            return null;
          }
          return saved.token;
        } catch (e) { return null; }
      }

      var ref = null;
      try {
        ref = new URLSearchParams(window.location.search).get('ref');
      } catch (e) { /* fall through to the remembered one */ }

      if (ref) {
        rememberRef(ref);
      } else {
        ref = recallRef();
      }
      if (!ref) return;

      // Held regardless of whether the name lookup succeeds: the lookup is only
      // for display, and a resolvable token should still credit the proposer
      // even if this request fails. The server re-resolves it either way, so a
      // stale or revoked token costs nothing beyond a banner that does not show.
      tokenField.value = ref;

      fetch(RESOLVE_FN_URL + '?token=' + encodeURIComponent(ref))
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (!data || !data.valid || !data.name) return;
          bannerText.textContent =
            'Start your application here. Yours will be tied to ' +
            data.name + '\u2019s referrals.';
          banner.style.display = 'block';

          // Same resolved name, shown again at the foot of the form. Only ever
          // revealed when the lookup succeeded, so an empty "Referred by" box
          // never sits there inviting someone to type a name into it.
          var referredWrap = document.getElementById('MFReferredBy');
          var referredName = document.getElementById('MFReferredByName');
          if (referredWrap && referredName) {
            referredName.value = data.name;
            referredWrap.style.display = '';
          }

          // The proposer is now known by name, so the typed box has nothing left
          // to ask and everything to lose: anything typed into it would replace
          // that name in the "as written" column. Cleared as well as hidden, so a
          // name typed before the lookup returned is not submitted from a field
          // the applicant can no longer see.
          var typedWrap = document.getElementById('MFMemberReferrals');
          var typedInput = document.getElementById('MFMemberReferralsInput');
          if (typedWrap && typedInput) {
            typedInput.value = '';
            typedWrap.style.display = 'none';
          }
        })
        .catch(function() { /* display only — never block the form */ });
    })();

    /* ── Under 30 eligibility ─────────────────────────────────────────────
       The Under 30 rate runs until the 31st birthday, so it can only be
       granted on or before the 30th. Someone could previously type any
       birthdate and still pick the Under 30 membership; nothing on either
       side checked the two against each other, so a 36 year old was accepted
       at the Under 30 price. The option now follows the birthdate above it.

       Nothing on the page explains why: the membership is called Under 30, so
       a greyed out option says enough (Brandon, 2026-10-21). Clearing a stale
       selection leaves the existing "Still missing" message to name the field,
       and the edge function refuses the pair for anything that gets past here. */
    var birthdateInput = form.querySelector('[name="birthdate"]');
    var membershipSelect = form.querySelector('[name="membership_type"]');
    var u30Option = membershipSelect ? membershipSelect.querySelector('option[value="under30"]') : null;

    /* True once the 30th birthday is behind them. The birthday itself still
       counts as under 30, which is what the portal's shared/under30.ts says.
       29 February in a non leap year lands on 1 March, the same way a birthday
       card would. */
    function pastThirtiethBirthday(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
      if (!m) return false;
      var thirtieth = Date.UTC(Number(m[1]) + 30, Number(m[2]) - 1, Number(m[3]));
      var now = new Date();
      var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
      return today > thirtieth;
    }

    function syncU30Option() {
      if (!membershipSelect || !u30Option) return;
      var blocked = pastThirtiethBirthday(val('birthdate'));
      u30Option.disabled = blocked;
      // A birthdate edited after the membership was chosen must not leave an
      // Under 30 selection sitting in a disabled option.
      if (blocked && membershipSelect.value === 'under30') membershipSelect.value = '';
    }

    if (birthdateInput) {
      birthdateInput.addEventListener('change', syncU30Option);
      birthdateInput.addEventListener('input', syncU30Option);
    }
    syncU30Option();

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.style.display = 'none';
      errBox.textContent = '';

      /* Client-side required check.
         This used to say "Please fill in all required fields." and stop there,
         which on a form this long tells you nothing: the field it moved focus
         to could be far off screen, so the message read as a dead end. It names
         the field now, and scrolls it into view. */
      var requiredFields = form.querySelectorAll('[required]');
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        if (field.type === 'checkbox' && !field.checked) {
          showError(CHECKBOX_ERRORS[field.name] || 'Please accept the policies to continue.');
          revealField(field);
          return;
        }
        if (field.type !== 'checkbox' && !field.value.trim()) {
          var what = labelFor(field);
          showError(what ? 'Still missing: ' + what : 'Please fill in all required fields.');
          revealField(field);
          return;
        }
      }

      /* The phone box is prefilled with a calling code, so `required` on its own
         would happily accept "+1" and nothing else. E.164 allows 15 digits
         including the code and nothing real is shorter than 8: the same rule
         the edge function and the Klaviyo sync both apply, so a number that
         passes here cannot be dropped later. */
      var phoneDigits = (val('phone') || '').replace(/\D/g, '');
      if (phoneDigits.length < 8 || phoneDigits.length > 15) {
        showError('Please enter your phone number after the country code.');
        var phoneField = form.querySelector('[name="phone"]');
        if (phoneField) revealField(phoneField);
        return;
      }

      var payload = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        pronouns: val('pronouns'),
        email: val('email'),
        phone: val('phone'),
        country: val('country'),
        address_line1: val('address_line1'),
        address_line2: val('address_line2'),
        address_city: val('address_city'),
        address_state: val('address_state'),
        address_postal_code: val('address_postal_code'),
        address_country: val('address_country'),
        birthdate: toSlashDate(val('birthdate')),
        occupation: val('occupation'),
        social_media_handle: buildSocialHandle(),
        social_contributions: val('social_contributions'),
        passions: val('passions'),
        ambition: val('ambition'),
        passion_projects: val('passion_projects'),
        space_inspiration: val('space_inspiration'),
        why_join: val('why_join'),
        membership_type: val('membership_type'),
        referral_token: val('referral_token'),
        how_did_you_hear: val('how_did_you_hear'),
        member_referrals: val('member_referrals'),
        newsletter_signup: form.querySelector('[name="newsletter_signup"]').checked,
        sms_consent: form.querySelector('[name="sms_consent"]').checked,
        accepted_terms: form.querySelector('[name="accepted_terms"]').checked
      };

      // Attach first-party traffic attribution (visitor id + first/last-touch source).
      try {
        if (window.InochiTracker && window.InochiTracker.getAttribution) {
          var attribution = window.InochiTracker.getAttribution();
          for (var attrKey in attribution) {
            if (Object.prototype.hasOwnProperty.call(attribution, attrKey)) {
              payload[attrKey] = attribution[attrKey];
            }
          }
        }
      } catch (attrErr) { /* attribution is best-effort — never block submission */ }

      btn.disabled = true;
      btn.textContent = 'Submitting...';

      fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function(result) {
        if (result.ok) {
          form.style.display = 'none';
          successBox.style.display = 'block';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          showError(result.data.error || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      })
      .catch(function() {
        showError('Unable to reach the server. Please check your connection and try again.');
        btn.disabled = false;
        btn.textContent = 'Submit';
      });
    });

    /* A few labels do not stand on their own once lifted out of the form.
       "Number" sits under a Phone heading and means nothing by itself. */
    /* Every required checkbox says what IT is for. Falling through to one
       generic line left someone hunting for which box they had missed. */
    var CHECKBOX_ERRORS = {
      newsletter_signup: 'Please check "I consent to receiving member emails from Inochi". That is how we email you about your application.',
      sms_consent: 'Please check "I consent to receiving member texts from Inochi" to continue.'
    };

    var FIELD_NAMES = {
      phone: 'Phone number',
      address_state: 'State / Province / Region',
      address_state_text: 'State / Province / Region'
    };

    /* The visible label for a field, so an error can name it rather than
       leaving someone to hunt through a long form for whatever is blank.
       Original capitalisation is kept, because several of these labels are
       whole questions and reading them back lowercased looks like a typo. */
    function labelFor(field) {
      if (field.name && FIELD_NAMES[field.name]) return FIELD_NAMES[field.name];
      var label = field.id ? form.querySelector('label[for="' + field.id + '"]') : null;
      if (!label) {
        var wrapper = field.closest ? field.closest('.inochi-field, .inochi-form-row, p, div') : null;
        label = wrapper ? wrapper.querySelector('label') : null;
      }
      if (!label) return '';
      return (label.textContent || '')
        .replace(/\(optional\)/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/[:*]+$/, '');
    }

    /* Focus alone can leave the field off screen on a long form. */
    function revealField(field) {
      try { field.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* older browsers */ }
      try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
    }

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    /* ── Country and state ────────────────────────────────────────────────
       The state field is a picker for the two countries we hold subdivisions
       for and a plain text box everywhere else, because guessing at another
       country's regions is worse than letting someone type their own. Only the
       visible one is ever submitted, so `address_state` carries a code for
       US and CA and free text elsewhere. */
    var SUBDIVISIONS = {
      US: [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],['AS','American Samoa'],['GU','Guam'],['MP','Northern Mariana Islands'],['PR','Puerto Rico'],['VI','U.S. Virgin Islands'],['AA','Armed Forces Americas'],['AE','Armed Forces Europe'],['AP','Armed Forces Pacific']],
      CA: [['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],['SK','Saskatchewan'],['YT','Yukon']]
    };
    /* ── Phone country code ───────────────────────────────────────────────
       The picker beside the phone box is what tells us how to read the number,
       so the box carries that country's calling code as real text rather than a
       grey hint. Switching country rewrites the code and keeps whatever has
       already been typed after it.

       The code is read from data-dial on the option itself, so this form holds
       no country table of its own and cannot drift out of step with the list.
       Regenerate both together in the portal repo:
         node scripts/generate-geo.mjs --options                              */
    var phoneCountrySel = form.querySelector('[name="country"]');
    var phoneInput = form.querySelector('[name="phone"]');
    var currentDial = '';

    function selectedDial() {
      var opt = phoneCountrySel && phoneCountrySel.options[phoneCountrySel.selectedIndex];
      return (opt && opt.getAttribute('data-dial')) || '';
    }

    /* rewrite=false on load: only fill an empty box, never clobber a value the
       browser restored. rewrite=true on change: swap the code we put there and
       carry the rest of the number across. */
    function applyDial(rewrite) {
      var next = selectedDial();
      if (!next || !phoneInput) return;
      var value = (phoneInput.value || '').trim();
      if (rewrite) {
        var head = currentDial ? '+' + currentDial : '';
        var rest = (head && value.indexOf(head) === 0) ? value.slice(head.length) : value;
        rest = rest.replace(/^[\s\-().]+/, '');
        phoneInput.value = rest ? '+' + next + ' ' + rest : '+' + next + ' ';
      } else if (!value) {
        phoneInput.value = '+' + next + ' ';
      }
      currentDial = next;
    }

    if (phoneCountrySel && phoneInput) {
      applyDial(false);
      phoneCountrySel.addEventListener('change', function () { applyDial(true); });
    }

    var countrySel = form.querySelector('[name="address_country"]');
    var stateSel = form.querySelector('#MFAddressState');
    var stateText = form.querySelector('#MFAddressStateText');
    var stateLabel = form.querySelector('label[for="MFAddressState"]');

    function syncStateField() {
      var list = SUBDIVISIONS[countrySel ? countrySel.value : 'US'];
      if (!stateSel || !stateText) return;

      if (list) {
        var placeholder = countrySel.value === 'CA' ? 'Select a province' : 'Select a state';
        stateSel.innerHTML = '<option value="">' + placeholder + '</option>' +
          list.map(function (row) { return '<option value="' + row[0] + '">' + row[1] + '</option>'; }).join('');
        stateSel.style.display = '';
        stateSel.disabled = false;
        stateSel.required = true;
        stateSel.name = 'address_state';
        stateText.style.display = 'none';
        stateText.disabled = true;
        stateText.required = false;
        stateText.name = 'address_state_text';
        if (stateLabel) stateLabel.textContent = countrySel.value === 'CA' ? 'Province' : 'State';
      } else {
        stateSel.style.display = 'none';
        stateSel.disabled = true;
        stateSel.required = false;
        stateSel.name = 'address_state_unused';
        stateText.style.display = '';
        stateText.disabled = false;
        stateText.required = true;
        stateText.name = 'address_state';
        if (stateLabel) stateLabel.textContent = 'State / Province / Region';
      }
    }

    if (countrySel) {
      countrySel.addEventListener('change', function () {
        // A California code means nothing in France, so the old answer goes.
        if (stateSel) stateSel.value = '';
        if (stateText) stateText.value = '';
        syncStateField();
      });
      syncStateField();
    }


    // Combine the Instagram & TikTok handles into the single social_media_handle
    // field the edge function / members portal already expect (keeps funnel intact)
    function buildSocialHandle() {
      var parts = [];
      var li = val('linkedin_handle').trim();
      var ig = val('instagram_handle').trim();
      var tt = val('tiktok_handle').trim();
      if (li) parts.push('LinkedIn: ' + li);
      if (ig) parts.push('Instagram: ' + ig);
      if (tt) parts.push('TikTok: ' + tt);
      return parts.join(' | ');
    }

    // Native date inputs emit YYYY-MM-DD; the members portal expects MM/DD/YYYY
    function toSlashDate(v) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
      return m ? m[2] + '/' + m[3] + '/' + m[1] : v;
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.style.display = 'block';
      errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inochi-mission-hills"]) return;
  try {
    
  (function() {
    var EDGE_FN_URL = 'https://ywjeykuqfybbekpdieip.supabase.co/functions/v1/submit-newsletter-signup';
    var SOURCE = 'shopify-taste-of-mission-hills';

    var form = document.getElementById('TasteOfMissionHillsForm');
    var btn = document.getElementById('TomhSubmit');
    var errBox = document.getElementById('TomhError');
    var successBox = document.getElementById('TomhSuccess');

    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.style.display = 'none';
      errBox.textContent = '';

      /* Each required checkbox says what IT is for, rather than one generic
         line that leaves someone hunting for the box they missed. */
      var CHECKBOX_ERRORS = {
        newsletter_signup: 'Please check "I consent to receiving member emails from Inochi" to continue.',
        sms_consent: 'Please check "I consent to receiving member texts from Inochi" to continue.'
      };

      var requiredFields = form.querySelectorAll('[required]');
      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        /* A checkbox is never empty: its value is "Yes" whether or not it is
           ticked, so testing .value here would let an unticked box straight
           through. */
        if (field.type === 'checkbox') {
          if (!field.checked) {
            showError(CHECKBOX_ERRORS[field.name] || 'Please tick the boxes to continue.');
            field.focus();
            return;
          }
          continue;
        }
        if (!field.value.trim()) {
          showError('Please fill in all required fields.');
          field.focus();
          return;
        }
      }

      var payload = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        email: val('email'),
        phone: val('phone'),
        newsletter_signup: form.querySelector('[name="newsletter_signup"]').checked,
        sms_consent: form.querySelector('[name="sms_consent"]').checked,
        source: SOURCE
      };

      btn.disabled = true;
      btn.textContent = 'Submitting...';

      fetch(EDGE_FN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function(result) {
        if (result.ok) {
          form.style.display = 'none';
          successBox.style.display = 'block';
        } else {
          showError(result.data.error || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      })
      .catch(function() {
        showError('Unable to reach the server. Please check your connection and try again.');
        btn.disabled = false;
        btn.textContent = 'Submit';
      });
    });

    function val(name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    }

    function showError(msg) {
      errBox.textContent = msg;
      errBox.style.display = 'block';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
